// API
import BaseApi from './base';

class CatGastosApi extends BaseApi {
  constructor() {
    super('catGastos');
  }

  filtraProcesos(params = {}) {
    return this.request.get(`catGastos`, {
      params: {
        ...params
      }
    });
  }
}

export default new CatGastosApi();
